import React from 'react';
import { Link } from 'react-router-dom';

function FreeSeoAuditCta({ className = '' }) {
  return (
    <section
      className={`rounded-2xl border border-indigo-200 bg-indigo-50/90 p-5 sm:p-6 ${className}`}
      aria-labelledby="free-seo-audit-cta"
    >
      <h2 id="free-seo-audit-cta" className="text-lg font-bold text-gray-900 mb-2">
        FREE SEO audit
      </h2>
      <p className="text-gray-700 text-sm leading-relaxed mb-4">
        Technical, on-page and Core Web Vitals checks—useful whether you are comparing agencies or planning a new site.
      </p>
      <Link
        to="/check-your-seo"
        className="inline-flex items-center justify-center px-5 py-2.5 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors text-sm"
      >
        Run the free SEO audit
      </Link>
    </section>
  );
}

export default FreeSeoAuditCta;
